import { render, staticRenderFns } from "./confidentialite.vue?vue&type=template&id=1487ff5b"
import script from "./confidentialite.vue?vue&type=script&lang=js"
export * from "./confidentialite.vue?vue&type=script&lang=js"
import style0 from "./confidentialite.vue?vue&type=style&index=0&id=1487ff5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports